import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as API from '../../api.js';
import { getCollectionImages } from '../../api';
import { BLOB_URL } from '../../AppConstants';
import { getFeaturesPermissions, PICSTORK_FEATURES } from '../../Teams';
import { set } from 'date-fns';
import TransTowerIcon from "../../icons/TransTowerIcon.svg";
import { useHistory } from "react-router-dom";
import ButtonWithIcon from '../../ReusableComponents/ButtonWithIcon.js';
import whitePlus from "../../assets/Icons/whiteplus.png";
import CreateTower from './CreateTower.js';

const RecentTowers = () => {
  const history = useHistory();
  const [towersData, setTowersData] = useState([]);
  const [RawtowersData, setRawTowersData] = useState([]);
  const [thumbnails, setThumbnails] = useState({});
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    // Fetch permissions first
    getFeaturesPermissions([PICSTORK_FEATURES.IMAGECOLLECTIONS])
      .then((perms) => {
        setPermissions(perms);
      })
      .catch((e) => {
        console.error("Error fetching permissions:", e);
      });
  }, []);

  useEffect(() => {
    // Fetch towers after permissions are loaded
    if (permissions.container) {
      Towers();
    }
  }, [permissions]);

  const Towers = async () => {
    try {
      setLoading(true);
      const response = await API.getAllProjects(
        " ",
        10000,
        0,
        null,
        "PicStork",
        null,
        null,
        'created_date',
        'DESC'
      );
      setRawTowersData(response.projects || []);
      const towers = response.projects.map((item, index) => ({
        id: item.id || index + 1,
        project_name: item.project_name || 'Untitled Project',
        created_date: new Date(item.created_date).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }),
        image: item.image,
        collection_id: item.collection_id,
      }));

      setTowersData(towers);

      // Fetch thumbnails for projects that have images
      fetchThumbnails(towers);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchThumbnails = async (towers) => {
    const thumbnailPromises = towers.map(async (tower) => {
      if (tower.collection_id && tower.image) {
        try {
          const res = await getCollectionImages(tower.collection_id, "", 1, 0);
          if (res?.sasToken) {
            const imageUrl = `${BLOB_URL}/${permissions.container}/FlightImages/collection-${tower.collection_id}/thumb-${tower.image}?${res.sasToken}`;
            return { towerId: tower.id, url: imageUrl };
          }
        } catch (error) {
          console.error(`Error fetching thumbnail for tower ${tower.id}:`, error);
        }
      }
      return null;
    });

    const results = await Promise.all(thumbnailPromises);
    const thumbnailMap = {};
    results.forEach(result => {
      if (result) {
        thumbnailMap[result.towerId] = result.url;
      }
    });
    setThumbnails(thumbnailMap);
  };

  return (
    <div
      style={{
        borderRadius: "10px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Fixed Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexShrink: 0,
        }}
      >
       <div style={{display:"flex"}}>
        <p
          style={{
            fontSize: "16px",
            margin: "0",
            color: "#333",
            fontWeight: 500,
            color: "#18242D",
          }}
        >
          Recent Projects
        </p>
        
        

        {towersData.length === 0 &&
          <>
          <ButtonWithIcon
                                text=""
                                icon={whitePlus}
                                onClick={() => setIsCreateModalOpen(true)}
                                isDisabled={false}
                                backgroundColor="#2989CF"
                                border="1px solid #2989CF"
                              />
          <CreateTower
                              isOpen={isCreateModalOpen}
                              onRequestClose={() => setIsCreateModalOpen(false)}
                              onSubmit={(newTower) => {
                                Towers()
                              }}
                            />
                            </>
        }
        
        </div>
        <div>
        {towersData?.length > 0 && (
          <Link
            to="/picstork/towers?fromDashBoard=true"
            style={{
              color: "#007bff",
              textDecoration: "underline",
              fontSize: "13px",
              fontWeight: "normal",
            }}
          >
            <span style={{ textDecoration: "underline" }}>View All</span>
          </Link>
        )}
        </div>
      </div>

      {/* Scrollable List Container */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingRight: "5px",
        }}
      >
        {loading ? (
          <div
            style={{
              textAlign: "center",
              color: "#666",
              fontSize: "14px",
              marginTop: "40px",
            }}
          >
            Loading towers...
          </div>
        ) : towersData.length === 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              marginTop: "50px",
              color: "#666",
            }}
          >
            <img
              src={TransTowerIcon}
              alt="Trans Icon"
              style={{
                width: "90px",
                height: "90px",
                marginBottom: "10px",
              }}
            />
            <div>No Towers Found !</div>
          </div>
        ) : (
          towersData.map((tower, index) => (
            <div
              key={tower.id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0",
                borderBottom:
                  index < towersData.length - 1 ? "1px solid #e0e0e0" : "none",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* Thumbnail or placeholder */}
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "6px",
                    marginRight: "15px",
                    flexShrink: 0,
                    overflow: "hidden",
                    backgroundColor: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {thumbnails[tower.id] ? (
                    <img
                      src={thumbnails[tower.id]}
                      alt={tower.project_name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.parentElement.style.background =
                          "linear-gradient(45deg, #90EE90 25%, #32CD32 25%, #32CD32 50%, #90EE90 50%, #90EE90 75%, #32CD32 75%)";
                        e.target.parentElement.style.backgroundSize = "3px 3px";
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        background:
                          "linear-gradient(45deg, #90EE90 25%, #32CD32 25%, #32CD32 50%, #90EE90 50%, #90EE90 75%, #32CD32 75%)",
                        backgroundSize: "3px 3px",
                      }}
                    ></div>
                  )}
                </div>

                <div style={{ minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: "14px",
                      marginBottom: "2px",
                      color: "#333",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {tower.project_name}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginBottom: "0px",
                    }}
                  >
                    {tower.created_date}
                  </div>
                </div>
              </div>
              {/* <Link
          to={{
            pathname: "/picstork/towers",
            state: { projectId:index }
          }}
          style={{
                padding: '6px 16px',
                border: '1px solid #007bff',
                backgroundColor: 'transparent',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: '500',
                color: '#007bff',
                cursor: 'pointer',
                flexShrink: 0,
                transition: 'all 0.2s',
              }}
        >
          Open
        </Link> */}
              <button
                style={{
                  padding: "6px 16px",
                  border: "1px solid #007bff",
                  backgroundColor: "transparent",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "#007bff",
                  cursor: "pointer",
                  flexShrink: 0,
                  transition: "all 0.2s",
                }}
                onClick={() => {
                  history.push(`/picstork/tower-plans?fromDashBoard=true`, {
                    rowData: tower,
                  });
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#007bff";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#007bff";
                }}
              >
                Open
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecentTowers;